module.exports = __webpack_public_path__ + "fonts/Roboto-Light.25e374a1.ttf";